export const purchaseOrdersEndpoints = {
  getPurchaseOrderByRequestId: { method: 'get', path: '/by-request/{requestId}' },
  updatePurchaseOrder: { method: 'post', path: '/{purchaseOrderId}/update' },
} as const
